import Typography from '@sharedComponents/Typography';
import { useTranslation } from 'react-i18next';

import * as style from './style.module.css';

// Number of characters of a field against its maximum, in red beyond it.
const CharacterCount = ({ length, max }) => {
    const { t } = useTranslation('bo');
    return (
        <Typography fontSize="s" color={length > max ? 'error-primary' : 'neutral-tertiary'} className={style.count}>
            {t('Number of characters: {{length}}/{{max}}', { length, max })}
        </Typography>
    );
};

export default CharacterCount;
